import { render, staticRenderFns } from "./SWMA_SettingsWindow.vue?vue&type=template&id=a547ac3c&scoped=true"
import script from "./SWMA_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./SWMA_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a547ac3c",
  null
  
)

export default component.exports